/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type AIConfigTargetingDefaults = {
  onVariation: number;
  offVariation: number;
};

/** @internal */
export const AIConfigTargetingDefaults$inboundSchema: z.ZodType<
  AIConfigTargetingDefaults,
  z.ZodTypeDef,
  unknown
> = z.object({
  onVariation: z.number().int(),
  offVariation: z.number().int(),
});
/** @internal */
export type AIConfigTargetingDefaults$Outbound = {
  onVariation: number;
  offVariation: number;
};

/** @internal */
export const AIConfigTargetingDefaults$outboundSchema: z.ZodType<
  AIConfigTargetingDefaults$Outbound,
  z.ZodTypeDef,
  AIConfigTargetingDefaults
> = z.object({
  onVariation: z.number().int(),
  offVariation: z.number().int(),
});

export function aiConfigTargetingDefaultsToJSON(
  aiConfigTargetingDefaults: AIConfigTargetingDefaults,
): string {
  return JSON.stringify(
    AIConfigTargetingDefaults$outboundSchema.parse(aiConfigTargetingDefaults),
  );
}
export function aiConfigTargetingDefaultsFromJSON(
  jsonString: string,
): SafeParseResult<AIConfigTargetingDefaults, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AIConfigTargetingDefaults$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AIConfigTargetingDefaults' from JSON`,
  );
}
